'use strict';

// export this package's api
module.exports = require('./Animate');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-animate/lib/index.js
 ** module id = 16
 ** module chunks = 0
 **/